import { render, staticRenderFns } from "./ticket-type.vue?vue&type=template&id=ce73f20c&scoped=true&"
import script from "./ticket-type.vue?vue&type=script&lang=js&"
export * from "./ticket-type.vue?vue&type=script&lang=js&"
import style0 from "./ticket-type.vue?vue&type=style&index=0&id=ce73f20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce73f20c",
  null
  
)

export default component.exports